import React, { useState } from "react";
import MetadataForm from "./MetadataForm";

const LessonCreateTab = ({ onCreated }) => {
  const [content, setContent] = useState("");
  const [showMetadataForm, setShowMetadataForm] = useState(false);
  const [saveStatus, setSaveStatus] = useState("");

  const handleSaveLessonClick = () => {
    if (!content.trim()) {
      alert("Please enter lesson content before saving");
      return;
    }
    setShowMetadataForm(true);
  };

  const handleMetadataFormSave = (lesson) => {
    setShowMetadataForm(false);
    setSaveStatus("Lesson saved successfully!");
    setContent("");

    if (onCreated) {
      onCreated();
    }

    setTimeout(() => setSaveStatus(""), 3000);
  };

  const handleMetadataFormCancel = () => {
    setShowMetadataForm(false);
  };

  return (
    <div className="tab-content">
      <div style={{ width: "100%", maxWidth: "100%", margin: "20px 0" }}>
        <h2>Create New Lesson</h2>

        <div className="form-group">
          <label>Lesson Content * (Markdown)</label>
          <textarea
            value={content}
            onChange={(e) => setContent(e.target.value)}
            placeholder="Enter lesson content in markdown format..."
            rows="15"
            style={{
              width: "100%",
              padding: "12px",
              border: "1px solid rgba(59, 130, 246, 0.15)",
              borderRadius: "8px",
              background: "#050e1a",
              color: "white",
              fontFamily: "inherit",
              fontSize: "14px",
              boxSizing: "border-box",
            }}
          />

          {/* Markdown Formatting Guide */}
          <details style={{ marginTop: "20px", padding: "16px", background: "rgba(59, 130, 246, 0.05)", borderRadius: "8px", border: "1px solid rgba(59, 130, 246, 0.15)" }}>
            <summary style={{ cursor: "pointer", fontWeight: "600", color: "#5B9EF0", fontSize: "14px", userSelect: "none" }}>
              Markdown Formatting Guide
            </summary>
            <div style={{ marginTop: "12px", color: "#9DB4D4", fontSize: "13px", lineHeight: "1.6" }}>
              <h4 style={{ color: "#5B9EF0", marginTop: "12px", marginBottom: "8px" }}>Fence Types (Info Boxes)</h4>
              <ul style={{ marginLeft: "20px" }}>
                <li><code>:::tip</code> - Green info box with 💡 icon</li>
                <li><code>:::warning</code> - Orange warning box with ⚠️ icon</li>
                <li><code>:::error</code> - Red error box with ❌ icon</li>
                <li><code>:::info</code> - Blue info box with ℹ️ icon</li>
                <li><code>:::question</code> - Yellow question box with ? icon</li>
                <li><code>:::button Label, URL</code> - Clickable button (orange)</li>
              </ul>

              <h4 style={{ color: "#5B9EF0", marginTop: "12px", marginBottom: "8px" }}>Basic Formatting</h4>
              <ul style={{ marginLeft: "20px" }}>
                <li><code>**text**</code> - Bold</li>
                <li><code>*text*</code> - Italic</li>
                <li><code>`code`</code> - Inline code</li>
                <li><code># Heading</code> - Large heading</li>
                <li><code>- [ ]</code> - Checkbox (read-only)</li>
                <li><code>[text](url)</code> - Link</li>
              </ul>

              <h4 style={{ color: "#5B9EF0", marginTop: "12px", marginBottom: "8px" }}>Examples</h4>
              <div style={{ background: "#050e1a", padding: "12px", borderRadius: "6px", overflow: "auto", marginTop: "8px", border: "1px solid rgba(59, 130, 246, 0.2)" }}>
                <pre style={{ margin: "0", color: "#5B9EF0", fontSize: "12px" }}>
{`:::tip
This is a helpful tip
:::

:::question
Why is this important?
:::

:::button Get Started, https://example.com
:::

**Bold text** and *italic text*

- Bullet 1
- Bullet 2`}
                </pre>
              </div>

              <p style={{ marginTop: "12px", color: "#7A9CC4", fontSize: "12px" }}>
                📥 Download the full guide: <a href="/MARKDOWN_FORMATTING_GUIDE.md" style={{ color: "#5B9EF0", textDecoration: "underline" }}>MARKDOWN_FORMATTING_GUIDE.md</a>
              </p>
            </div>
          </details>
        </div>

        <div className="form-actions" style={{ display: "flex", gap: "10px" }}>
          <button
            className="save-button"
            onClick={handleSaveLessonClick}
            style={{
              padding: "12px 24px",
              background: "#3b82f6",
              color: "white",
              border: "none",
              borderRadius: "8px",
              fontSize: "14px",
              fontWeight: "600",
              cursor: "pointer",
            }}
          >
            Save as Lesson
          </button>
        </div>

        {saveStatus && (
          <div
            style={{
              marginTop: "16px",
              padding: "12px",
              background: "#22C55E20",
              color: "#22C55E",
              borderRadius: "6px",
            }}
          >
            {saveStatus}
          </div>
        )}
      </div>

      {showMetadataForm && (
        <MetadataForm
          content={content}
          onSave={handleMetadataFormSave}
          onCancel={handleMetadataFormCancel}
        />
      )}
    </div>
  );
};

export default LessonCreateTab;
